import React from 'react';
import * as FaIcons from 'react-icons/fa';
import { guardarCompensacion, updateCompensacionGrupos } from '../firebase';

function MedirCompensacion ( props ) {

  //console.log(props.user.email)
  const yearSelect = 2019;
  const [nombre, setNombre] = React.useState('');
  const [cantidadArboles, setCantidadArboles] = React.useState(0);
  const [year, setYear] = React.useState(2019);
  const [isDisabled, setDisabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const [grupoEspecie, setGrupoEspecie] = React.useState('');

  const [inputFields, setInputFields] = React.useState([{grupo:'', cant:'', especie:''}])

  const [cant, setCant ] = React.useState({grupo:'grupo0',cant:0})
  const [grupoArb, setGrupoArb] = React.useState([])


  const [cant1, setCant1 ] = React.useState()
  const [cant2, setCant2 ] = React.useState()
  const [cant3, setCant3 ] = React.useState()
  const [cant4, setCant4 ] = React.useState()
  const [cant5, setCant5 ] = React.useState()
  const [cant6, setCant6 ] = React.useState()

  const onChangeCant1 = (event) => {
    setCant1(event.target.value)
    console.log(event.target.value)

  }
  const onChangeCant2 = (event) => {
    setCant2(event.target.value)
    console.log(event.target.value)
  }
  const onChangeCant3 = (event) => {
    setCant3(event.target.value)
    console.log(event.target.value)
  }
  const onChangeCant4 = (event) => {
    setCant4(event.target.value)
    console.log(event.target.value)
  }
  const onChangeCant5 = (event) => {
    setCant5(event.target.value)
    console.log(event.target.value)
  }
  const onChangeCant6 = (event) => {
    setCant6(event.target.value)
    console.log(event.target.value)
  }
  let cantidades = []
  React.useEffect (() => {
    console.log(props.grupos)

    var items = [...props.grupos]
    items.sort((a,b) =>
      a.nombre.localeCompare(b.nombre)
    );
    console.log(items)
    items.map(it =>{
      console.log(it.nombre)
    })
    setGrupoArb(items)
  }, [props.grupos]);
  const onChangeNombre = (event) => {
    setNombre(event.target.value);
    valida();
  }

  const onChangeYear = (event) => {
    setYear(event.target.value);
  }

  const valida = () => {
    
    document.getElementById('agregarEntrada').style.color = 'darkgray'
    if (nombre === '') { setDisabled(true); console.log('Disabled TRUE'); return false; }
    
    setDisabled(false);
    document.getElementById('agregarEntrada').style.color = '#111FA1'
    console.log('Disabled FALSE')
    //return true;
  }
  const submit = async (event) => {
    event.preventDefault();
      setLoading(true);
      setDisabled(true);
      let compensacion = {
        nombre_proyecto: nombre,
        year: Number(year)
        //user_email: props.user.email
      }
      let cantTotal = Number(0);
      let captura = Number(0);
      props.grupos.map((grupo, index) => {
        let potencial = Number(grupo.potencial_captura);
        console.log(potencial)
        console.log(cant+index)
        compensacion[grupo.nombre] = grupo.nombre; 
        if (grupo.nombre === 'Grupo1') { captura += Number(cant1) * 65.8; compensacion["cant1"] = Number(cant1); cantTotal+=Number(cant1)}
        if (grupo.nombre === 'Grupo2') { captura += Number(cant2) * 50.1; compensacion["cant2"] = Number(cant2); cantTotal+=Number(cant2)}
        if (grupo.nombre === 'Grupo3') { captura += Number(cant3) * 53.7; compensacion["cant3"] = Number(cant3); cantTotal+=Number(cant3)}
        if (grupo.nombre === 'Grupo4') { captura += Number(cant4) * 109.2;compensacion["cant4"] = Number(cant4); cantTotal+=Number(cant4)}
        if (grupo.nombre === 'Grupo5') { captura += Number(cant5) * 53.4; compensacion["cant5"] = Number(cant5); cantTotal+=Number(cant5)}
        if (grupo.nombre === 'Grupo6') { captura += Number(cant6) * 66.42;compensacion["cant6"] = Number(cant6); cantTotal+=Number(cant6)}
        
      })
      compensacion["total_captura"] = captura;
      compensacion["cantTotal"] = cantTotal;
      /*let captura = 0;
      inputFields.map((input, index) => {
        console.log('index = '+index);
        console.log('input ='+input.grupo +' -- '+input.cant);
        compensacion["grupo"+ (index +1)] = input.grupo;
        compensacion["cant"+ (index +1)] = Number(input.cant);
        if (input.grupo === 'Grupo1') { captura = captura + Number(input.cant) * 65.8; }
        if (input.grupo === 'Grupo2') { captura = captura + Number(input.cant) * 50.1; }
        if (input.grupo === 'Grupo3') { captura = captura + Number(input.cant) * 53.7; }
        if (input.grupo === 'Grupo4') { captura = captura + Number(input.cant) * 109.2; }
        if (input.grupo === 'Grupo5') { captura = captura + Number(input.cant) * 53.4; }
        if (input.grupo === 'Grupo6') { captura = captura + Number(input.cant) * 66.42; }
        //captura = captura + Number(input.cant) * 2.7;
      })
      compensacion["total_captura"] = captura;*/
      console.log(compensacion)
      updateCompensacionGrupos();
      enviarGuardado(compensacion)
  }
  const enviarGuardado = async (compensacion) =>{

      const result = await guardarCompensacion(compensacion);
      if (result) {
          console.log(result);
          setNombre('');
          setCantidadArboles(0);
          setYear(2019);
          setDisabled(true);
          console.log('Enviando actualizar la tabla')
          props.parentCallback(true);
      }else{
        alert('Ocurrió un error inesperado, por favor refresque la página e intente de nuevo.')
      }
      setLoading(false);
  }
  const onChangeGrupos = (index, event) => {
    console.log(index)
    console.log(event.target.name)
    console.log(event.target.value)
    cantidades.push(event.grupo.value);
    //var cants = [...cant]
    //cants.push(event.target.value)
    //setCant(cants)
    /*let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
    if (event.target.value.includes('Grupo')) {
      let grupo = props.grupos.find((grupo) => {return grupo.nombre === event.target.value})
      console.log(grupo.Especies)
      setGrupoEspecie(grupo.Especies)
    }*/
  }
  const addInputsGrupo = () => {
    let newInput = {grupo:'', cant:'', especie:''}
    setInputFields([...inputFields, newInput])
  }
  
  return (
    <div style={{ padding:'30px'  }} className='bg_div'>
      <div className='medicionMenu'>
        <h1>Compensación</h1>
        
        <form style={{border:'1px solid blue',padding:'10px',borderRadius:'25px',boxShadow:'0 6px 20px rgb(56 125 255 / 17%)'}} onSubmit={submit}>
          <FaIcons.FaTree style={{color:'#1010C5',marginLeft:'5px'}}/>
          <label style={{ marginLeft:'10px'}}>Proyecto de compensación</label>
          <br/>
          <button 
            style={{borderRadius:'7px',padding:'3px',border:'none',background:'lightblue'}}
            onClick={addInputsGrupo}> Nuevo grupo
          </button>
          <br/>
          <label style={{color:'darkseagreen'}}>{grupoEspecie}</label>
          <div className="form-group" >
            <label>Grupo1: Simarua, Cedro Trompillo</label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant1}
              onChange={event => onChangeCant1(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>
          <div className="form-group" >
            <label>Grupo2: Yopo, Cañofistol, Pavito, Gualanday, Orejero, Cabo de Hacha</label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant2}
              onChange={event => onChangeCant2(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>
          <div className="form-group" >
            <label>Grupo3: Algarrobo, Aceite</label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant3}
              onChange={event => onChangeCant3(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>
          <div className="form-group" >
            <label>Grupo4: Totumo, Arrayan, Palo Cruz, Marañon</label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant4}
              onChange={event => onChangeCant4(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>
          <div className="form-group" >
            <label>Grupo5: Caracolí, Nacedero, Bucaro, Maraco </label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant5}
              onChange={event => onChangeCant5(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>
          <div className="form-group" >
            <label>Grupo6: Especies Nuevas</label>
            <input required type="number" step='1' 
              name='cant'
              className='form-control'
              placeholder='Cantidad árboles'
              onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
              onInput={(e) => e.target.setCustomValidity('')} 
              value={cant6}
              onChange={event => onChangeCant6(event)}
              style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
            />
          </div>

          {
            /*grupoArb.map((grupo, index) => {
              return (
                <div key={index}>
                  <div className="form-group" key={index}>
                    <label>{grupo.nombre}:{ grupo.Especies}</label>
                    <input required type="number" step='1' 
                      name='cant'
                      className='form-control'
                      placeholder='Cantidad árboles'
                      onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                      onInput={(e) => e.target.setCustomValidity('')} 
                      value={cant}
                      onChange={event => onChangeGrupos(index, event)}
                      style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'75%',border:'1px solid #ced4da'}} 
                    />
                  </div>
                  

                </div>
              )
            })*/
          }
          <div className="form-group">
              <label>Nombre del proyecto</label>
              <input 
                type="text" 
                className="form-control" 
                value={nombre} 
                onChange={onChangeNombre}
                placeholder="Nombre proyecto" 
              />
          </div>

          {/*<div className="form-group">
              <label>Grupo 1 Especies</label>
              <input 
                type="text" 
                className="form-control" 
                value={grupo1} 
                onChange={onChangeGrupo1} 
                placeholder="Especie árbol" 
              />
          </div>
          <div className="form-group">
            <label>Cantidad árboles</label>
            <input required type="number" step='1' 
                className="form-control" 
                placeholder="Cantidad árboles"
                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                onInput={(e) => e.target.setCustomValidity('')} 
                value={cant1} 
                onChange={onChangeCantGrupo1}
                style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'50%',border:'1px solid #ced4da'}} 
            />
          </div>

          <div className="form-group">
              <label>Grupo 2 Especies</label>
              <input 
                type="text" 
                className="form-control" 
                value={grupo2} 
                onChange={onChangeGrupo2} 
                placeholder="Especie árbol" 
              />
          </div>
          <div className="form-group">
            <label>Cantidad árboles</label>
            <input required type="number" step='1' 
                className="form-control" 
                placeholder="Cantidad árboles"
                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                onInput={(e) => e.target.setCustomValidity('')} 
                value={cant2} 
                onChange={onChangeCantGrupo2}
                style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'50%',border:'1px solid #ced4da'}} 
            />
          </div>

          <div className="form-group">
              <label>Grupo 3 Especies</label>
              <input 
                type="text" 
                className="form-control" 
                value={grupo3} 
                onChange={onChangeGrupo3} 
                placeholder="Especie árbol" 
              />
          </div>
          <div className="form-group">
            <label>Cantidad árboles</label>
            <input required type="number" step='1' 
                className="form-control" 
                placeholder="Cantidad árboles"
                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                onInput={(e) => e.target.setCustomValidity('')} 
                value={cant3} 
                onChange={onChangeCantGrupo3}
                style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'50%',border:'1px solid #ced4da'}} 
            />
          </div>

          <div className="form-group">
              <label>Grupo 4 Especies</label>
              <input 
                type="text" 
                className="form-control" 
                value={grupo4} 
                onChange={onChangeGrupo4} 
                placeholder="Especie árbol" 
              />
          </div>
          <div className="form-group">
            <label>Cantidad árboles</label>
            <input required type="number" step='1' 
                className="form-control" 
                placeholder="Cantidad árboles"
                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                onInput={(e) => e.target.setCustomValidity('')} 
                value={cant4} 
                onChange={onChangeCantGrupo4}
                style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'50%',border:'1px solid #ced4da'}} 
            />
          </div>

          <div className="form-group">
            <label>Cantidad árboles sembrados</label>
            <input required type="number" step='1' 
                className="form-control" 
                placeholder="Cantidad árboles"
                onInvalid={(e) => e.target.setCustomValidity("Por favor ingrese una cantidad!")}
                onInput={(e) => e.target.setCustomValidity('')} 
                value={cantidadArboles} 
                onChange={onChangeCantArboles}
                style={{ borderRadius:'1.25rem',padding:'0.375rem 0.75rem',width:'50%',border:'1px solid #ced4da'}} 
            />
          </div>*/}
          <div className="form-group">
            <label>Año de siembra </label>
            <select className="form-control" value={year} onChange={onChangeYear} style={{width:'50%'}} >
                {
                    [...Array(20)].map((e, i) => (
                        <option key={i} value={i + yearSelect}>{i + yearSelect}</option>
                    ))
                }
            </select>
          </div>

          <button   
            id='agregarEntrada' 
            onClick={submit}
            disabled={isDisabled} 
            style={{marginLeft:'5%'}} 
            className='boton__agregar__entrada'
            >Agregar entrada
          </button>
          { loading &&
            <img style={{width:'40px'}} src='/loading.gif'></img>
          }
          
        </form>
        
      </div>
    </div>
  )
}

export { MedirCompensacion }
